import { FunctionComponent, useCallback, useContext } from 'react';
import darkLogo from '../../assets/images/ascend-logo.svg';
import lightLogo from '../../assets/images/ascend-logo.svg';
import ThemeState from '../../context/state/ThemeState';
import { useHistory } from 'react-router-dom';
import { appConfig } from '../../config/appConfig';

interface LogoProps {
    light?: Boolean;
    noMenu?: boolean;
    maxWidth?: number;
}

const Logo: FunctionComponent<LogoProps> = ({ light, noMenu = false, maxWidth }) => {
    const { currentTheme } = useContext(ThemeState),
        history = useHistory();
    const goHome = useCallback(() => {
        history.push(appConfig.homePage);
    }, [history]);

    return (
        <div
            className={`logo${noMenu ? ' logo--no-menu' : ''}`}
            onClick={goHome}
            style={maxWidth ? { width: maxWidth, maxWidth } : undefined}
        >
            <img
                src={
                    light
                        ? currentTheme.lightLogo || lightLogo
                        : currentTheme.logo || darkLogo
                }
                alt="Logo"
            />
        </div>
    );
};
export default Logo;
